/* DEPRECATION: This entire file and directory (src/components/Navbar) should be deleted when legacy version is gone */
import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Graphics } from "../../assets/elevva-pro-icons/graphics.svg";
import { ReactComponent as House } from "../../assets/elevva-pro-icons/house.svg";
import { ReactComponent as Message } from "../../assets/elevva-pro-icons/Message.svg";
import { ReactComponent as PersonalReview } from "../../assets/elevva-pro-icons/icon_group.svg";
import { ReactComponent as SignOut } from "../../assets/elevva-pro-icons/signOut.svg";
import { ReactComponent as Mob } from "../../assets/elevva-pro-icons/Mob.svg";
import { ReactComponent as Accounting } from "../../assets/elevva-pro-icons/accounting_icon.svg";
import {
    checkPathNavFoot,
    checkPathNavFootMobile,
    perlo,
} from "../../utils/utils.js";


export const Allitems = ({
    typeCustomer,
    handlePasswordUpdate,
    plan,
    companyInfo
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const items = [
        {
            name: "Admin",
            icon: <House />,
            ref: useRef(null),
            path: "/admin",
            roles: [10, 20],
        },
        {
            name: "Mob",
            icon: <Mob />,
            ref: useRef(null),
            path: "/mob",
            roles: [10, 20, 30],
        },
        {
            name: "Accounting",
            icon: <Accounting />,
            ref: useRef(null),
            path: "/accounting",
            roles: [10, 20],
        },
        {
            name: "PersonalReview",
            icon: <PersonalReview />,
            ref: useRef(null),
            path: "/dashboard-legacy",
            roles: [10, 30],
        },
        {
            name: "Graficas",
            icon: <Graphics />,
            ref: useRef(null),
            path: "/graphics",
            roles: [10, 30],
        },
        {
            name: "Message",
            icon: <Message />,
            ref: useRef(null),
            path: "/notifications",
            roles: [10, 20],
        },
        {
            name: "Nueva Versión",
            icon: <i className="bi bi-arrow-left-right" style={{ color: '#808FF3' }}></i>,
            ref: useRef(null),
            path: "/dashboard/home",
            roles: [10, 20, 30],
        },
        {
            name: "Cerrar sesión",
            icon: <SignOut />,
            ref: useRef(null),
            path: "out",
            roles: [10, 20, 30],
        },
    ];

    const isMobIntegrationEnabled = JSON.parse(
        localStorage.mob_integration || "false"
    );
    const role = Number(localStorage.elevva_role);

    const planType = companyInfo?.plan_type;
    const hasAccountingPermission = companyInfo?.accounting_permisson;

    const isAccountingAllowed = (
        (hasAccountingPermission) ||
        planType > 10
    );

    const filteredItems = items.filter(
        (item) => {
            if (item.name === "Accounting" && !isAccountingAllowed) return false;
            return (isMobIntegrationEnabled || item.name !== "Mob") && item.roles.includes(role);
        }
    );

    useEffect(() => {
        const updateActive = () => {
            filteredItems.forEach((item) => {
                if (!item.ref.current) return;

                const isExactMatch = item.path === location.pathname;
                const isSubRoute = location.pathname.startsWith(item.path + "/");

                if (isExactMatch || isSubRoute) {
                    item.ref.current.className =
                        "sidebar-option sidebar-option-active";
                    item.ref.current.active = true;
                } else {
                    item.ref.current.className = "sidebar-option";
                    item.ref.current.active = false;
                }
            });
        };

        if (
            !checkPathNavFoot(location.pathname, typeCustomer) ||
            !checkPathNavFootMobile(location.pathname, typeCustomer)
        ) {
            updateActive();
        }
    }, [location, filteredItems, typeCustomer]);


    const selectOption = (item) => {
        const current = item.ref.current;
        if (!current) return;

        filteredItems.forEach((el) => {
            if (el.ref.current) {
                el.ref.current.className = "sidebar-option";
                (el.ref.current).active = false;
            }
        });

        current.className = "sidebar-option sidebar-option-active";
        (current).active = true;

        if (item.path === "out") {
            perlo();
        } else if (item.path === "changePassword") {
            handlePasswordUpdate();
        } else {
            navigate(item.path);
        }
    };

    return (
        <div className="sidebar-container gap-1 d-flex flex-column w-100">
            {filteredItems.map((item, index) => (
                <div
                    key={index}
                    ref={item.ref}
                    id={`sidebar-item-${index}`}
                    className="sidebar-option"
                    onClick={() => selectOption(item)}
                >
                    <div className="sidebar-icon">{item.icon}</div>
                </div>
            ))}
        </div>
    );
};
